import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SaveSegmentInput, Segment } from '@core/interfaces';
import { isEmpty, sortBy } from 'lodash';

export class DialogSegmentsMapper {
  static toGeneralForm(segment: Segment, formBuilder: FormBuilder): FormGroup {
    return formBuilder.group({
      name: [segment.name || null, [Validators.required]]
    });
  }

  static toMaintenanceTypesForm(segment: Segment, formBuilder: FormBuilder): FormGroup {
    return formBuilder.group({
      maintenanceTypes: formBuilder.control(!isEmpty(segment.maintenanceTypes) ? segment.maintenanceTypes : null)
    });
  }

  static toSegmentMaintenanceFormsArray(segment: Segment, formBuilder: FormBuilder): FormArray {
    const segmentMaintenanceTypeForms = segment.segmentMaintenanceTypeForms || [];
    const segmentMaintenanceTypeFormsSorted = sortBy(segmentMaintenanceTypeForms, 'form.name');
    return formBuilder.array(
      segmentMaintenanceTypeFormsSorted.map((segmentMaintenanceTypeForm) => {
        return formBuilder.group({
          form: formBuilder.control(segmentMaintenanceTypeForm.form || null, [Validators.required]),
          requiredComplete: formBuilder.control(segmentMaintenanceTypeForm.requiredComplete || false),
          requiredReport: formBuilder.control(segmentMaintenanceTypeForm.requiredReport || false),
          requiredStart: formBuilder.control(segmentMaintenanceTypeForm.requiredStart || false),
          maintenanceType: formBuilder.control({
            id: segmentMaintenanceTypeForm.maintenanceType ? segmentMaintenanceTypeForm.maintenanceType.id : null,
            name: segmentMaintenanceTypeForm.maintenanceType ? segmentMaintenanceTypeForm.maintenanceType.name : null,
            isAllSelected: Boolean(segment.id && !segmentMaintenanceTypeForm.maintenanceType)
          }, [Validators.required]),
        });
      }));
  }

  static toSaveSegmentInput({
    segment,
    segmentsIds,
    generalForm,
    settingsTab,
    maintenanceTypesForm,
    segmentMaintenanceFormsArray
  }): SaveSegmentInput {
      return {
        segmentsIds,
        archived: segment.archived,
        name: generalForm.value.name,
        maintenanceTypeIds: this.toSegmentMaintenanceTypesInput({ settingsTab, maintenanceTypesForm }),
        segmentMaintenanceTypeForms: segmentMaintenanceFormsArray.value.map((form: Record<string, any>) => ({
          formId: form.form.id,
          requiredStart: form.requiredStart,
          requiredReport: form.requiredReport,
          requiredComplete: form.requiredComplete,
          maintenanceTypeId: form.maintenanceType.isAllSelected ? null : form.maintenanceType.id,
        }))
      };
  }

  static toSegmentMaintenanceTypesInput({ settingsTab, maintenanceTypesForm }): any {
    if (!settingsTab.segmentsSettingsForm.get('linkMaintenanceTypesToSegment').value) {
      return [];
    }

    const maintenanceTypes = maintenanceTypesForm.get('maintenanceTypes').value;
    const mappedMaintenanceTypes = maintenanceTypes
      ? maintenanceTypes.map((maintenanceType) => maintenanceType.id)
      : [];

    return mappedMaintenanceTypes;
  }
}
